// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = 283
// module chunks = 1 2 3 4